/* === AmourPrint CRO — PDP extras v7: song label once (placeholder=example), proof note, pair, CEO X always, lazy CEO 9s, size row === */
(function(){
  if(!/\/products\//.test(location.pathname))return;
  function css(){
    if(document.getElementById('ap-extra-css'))return;
    var c='.ap-pdp-proof{margin:10px 0 0;padding:8px 10px;background:#EAF6F2;border-radius:8px;font-size:11px;color:#6B6B67;}'+
      '.ap-fields-row{display:grid !important;grid-template-columns:1fr 1fr !important;gap:8px !important;align-items:start;}.ap-fields-row>*{margin:0 !important;width:auto !important;}'+
      '.ap-ceo-x{position:absolute;top:-9px;right:-9px;z-index:99999;width:24px;height:24px;border-radius:50%;border:none;background:#2C2C2A;color:#fff;font-size:16px;line-height:22px;cursor:pointer;box-shadow:0 1px 5px rgba(0,0,0,.35);padding:0;}'+
      '.ap-ceo-reveal{animation:apFade .5s ease;}@keyframes apFade{from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:none;}}';
    var s=document.createElement('style');s.id='ap-extra-css';s.textContent=c;document.head.appendChild(s);
  }
  function ceoEl(){
    var el=document.querySelector('video[src*="faq-teaser"], video[poster*="faq-teaser"], source[src*="faq-teaser"]');
    if(el)return el;
    var nodes=document.querySelectorAll('.product__info-container div, .product__info-wrapper div, body > div, body > aside');
    for(var i=0;i<nodes.length;i++){ var x=nodes[i]; if(/talk to our ceo/i.test(x.textContent||'') && x.querySelector('video,img') && x.children.length<10) return x; }
    return null;
  }
  function ceoContainer(el){
    var w=el, found=null;
    for(var n=0;n<8 && w && w.parentElement;n++){ var pos=getComputedStyle(w).position; if(pos==='fixed'||pos==='absolute'){ found=w; break; } w=w.parentElement; }
    return found || el.closest('div') || el;
  }
  function addCeoX(target){
    if(!target || target.querySelector('.ap-ceo-x'))return;
    try{ var nodes=target.querySelectorAll('button,a,span,i'); for(var i=0;i<nodes.length;i++){ var n=nodes[i]; if(n.classList&&n.classList.contains('ap-ceo-x'))continue; var s=(n.textContent||'').trim(); var al=(n.getAttribute&&(n.getAttribute('aria-label')||''))||'';
      if((s==='×'||s==='✕'||s==='✖'||s==='x'||s==='X'||/close|dismiss/i.test(al)) && n.children.length===0){ n.style.setProperty('display','none','important'); } } }catch(e){}
    if(getComputedStyle(target).position==='static') target.style.position='relative';
    var btn=document.createElement('button'); btn.type='button'; btn.className='ap-ceo-x'; btn.setAttribute('aria-label','Close'); btn.textContent='×';
    btn.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); target.style.display='none'; });
    target.appendChild(btn);
  }
  function ceoClose(){ var el=ceoEl(); if(!el)return; var t=ceoContainer(el); if(!t||t===document.body||t.tagName==='MAIN'||t.tagName==='HTML')return; addCeoX(t); }
  function lazyCeo(){
    var el=ceoEl(); if(!el)return;
    var cont=ceoContainer(el); if(!cont || cont===document.body || cont.tagName==='HTML' || cont.dataset.apLazy)return;
    cont.dataset.apLazy='1';
    try{ var v=cont.querySelector('video')||(el.tagName==='VIDEO'?el:null); if(v) v.preload='none'; }catch(e){}
    cont.style.setProperty('display','none','important');
    setTimeout(function(){ cont.style.removeProperty('display'); cont.classList.add('ap-ceo-reveal'); addCeoX(cont); }, 9000);
  }
  function proofNote(){
    if(document.querySelector('.ap-pdp-proof'))return;
    var b=document.querySelector('.product .product-form__buttons, .product-form__buttons'); if(!b||!b.parentNode)return;
    var d=document.createElement('div');d.className='ap-pdp-proof';
    d.innerHTML='✉ Don’t worry — we email a full proof for your approval before we print. Free unlimited revisions.';
    b.parentNode.insertBefore(d, b);
  }
  function setSongLabel(){
    var info=document.querySelector('.product__info-container, .product__info-wrapper'); if(!info)return;
    var want='Song & Artist (Or paste Lyrics)';
    var matches=[];
    info.querySelectorAll('label, legend, span, p, div').forEach(function(e){
      if(e.children.length>0)return;
      var t=(e.textContent||'').trim();
      if(/^song$/i.test(t) || /song\s*&\s*artist|add lyrics|paste lyrics/i.test(t)){ if(t.length<60) matches.push(e); }
    });
    if(matches.length){
      if(matches[0].dataset.apSongSet!=='1'){ matches[0].textContent=want; matches[0].dataset.apSongSet='1'; }
      for(var i=1;i<matches.length;i++){ if(matches[i].dataset.apSongSet!=='1'){ matches[i].style.setProperty('display','none','important'); matches[i].dataset.apSongSet='1'; } }
    }
    info.querySelectorAll('input,textarea').forEach(function(f){ var p=(f.placeholder||''); if(/^song$/i.test(p)||/song\s*&\s*artist|add lyrics|paste lyrics/i.test(p)) f.placeholder='e.g. "At Last" - Etta James'; });
  }
  function songLabelFix(){
    document.querySelectorAll('.product__info-container label, .product__info-wrapper label').forEach(function(l){
      if(l.getAttribute('data-ap-de')==='1')return;
      var t=(l.textContent||'').trim().replace(/\s+/g,' ');
      if(t.length<10)return;
      if(/song & artist|paste lyrics/i.test(t))return;
      var h=Math.floor(t.length/2);
      if(t.slice(0,h).trim()===t.slice(t.length-h).trim()){ l.textContent=t.slice(0,h).trim(); l.setAttribute('data-ap-de','1'); }
    });
  }
  function fieldWrap(el){return el.closest('.product__custom-liquid')||el.closest('.field')||el.parentElement;}
  function pairFields(){
    if(document.querySelector('.ap-fields-row'))return;
    var info=document.querySelector('.product__info-container, .product__info-wrapper'); if(!info)return;
    var n=document.getElementById('personalization-text')||document.getElementById('your-names');
    var d=document.getElementById('personalization-date')||document.getElementById('dates');
    if(!n||!d){
      info.querySelectorAll('input[type="text"], input:not([type]), textarea').forEach(function(f){
        var lbl=''; var p=f.closest('.field, .product__custom-liquid'); var L=p?p.querySelector('label'):f.previousElementSibling;
        if(L) lbl=(L.textContent||'').toLowerCase();
        lbl=lbl||(f.name||'').toLowerCase()||(f.placeholder||'').toLowerCase();
        if(!n && /name/.test(lbl)) n=f; else if(!d && /\bdate\b/.test(lbl) && !/update|validate/.test(lbl)) d=f;
      });
    }
    if(!n||!d)return;
    var nw=fieldWrap(n),dw=fieldWrap(d);
    if(!nw||!dw||nw===dw||nw.parentNode!==dw.parentNode)return;
    var row=document.createElement('div');row.className='ap-fields-row';nw.parentNode.insertBefore(row,nw);row.appendChild(nw);row.appendChild(dw);
  }
  function sizeRow(){
    var info=document.querySelector('.product__info-container, .product__info-wrapper'); if(!info)return;
    var sg=null; info.querySelectorAll('a,button').forEach(function(a){ if(sg)return; var t=(a.textContent||'').trim(); if(/size guide/i.test(t)&&t.length<20) sg=a; });
    if(!sg||sg.dataset.apSg)return;
    var vs=document.querySelector('.product variant-selects')||info;
    var lbl=null,c=vs.querySelectorAll('legend, label, .form__label');
    for(var i=0;i<c.length;i++){ var t=(c[i].textContent||'').trim(); if(/^size\b/i.test(t)&&t.length<14){ lbl=c[i]; break; } }
    if(!lbl||!lbl.parentNode)return;
    sg.dataset.apSg='1'; lbl.parentNode.classList.add('ap-size-row'); lbl.parentNode.appendChild(sg);
  }
  function boot(){ css();lazyCeo();proofNote();setSongLabel();songLabelFix();ceoClose();pairFields();sizeRow(); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',function(){setTimeout(boot,200);});
  setTimeout(boot,500);setTimeout(boot,1500);setTimeout(boot,3000);
})();
